'use strict';

var _ = require('lodash');
var JQXTreeNodeIdGeneratorFactory = function JQXTreeNodeIdGeneratorFactory() {
  function getNewNodeId(label) {
    return _.camelCase((label || '').toLowerCase()) + Date.now();
  }
  return {
    getNewNodeId: getNewNodeId
  };
};
module.exports = JQXTreeNodeIdGeneratorFactory;